import React from 'react';

import * as devSimulation from '../../services/devSimulation';
import ElectronWaterLinkService from '../../services/ElectronWaterLinkService';

/**
 * Panneau de simulation pour le developpement.
 *
 * Permet de travailler sur les ecrans Spintouch sans lancer Electron, sans
 * installer WaterLink Connect et sans photometre branche :
 *
 *   Electron    l'application se croit en mode desktop
 *   WaterLink   le service WaterLink Connect repond
 *   Spintouch   un photometre est branche et pret
 *
 * Uniquement rendu en developpement : les scripts build_* de CRA passent
 * NODE_ENV a 'production', ce composant retourne alors null et le bloc est
 * elimine du bundle.
 *
 * Chaque bascule recharge la page : les composants lisent l'etat au montage
 * (Home construit isElectron des le constructeur, les ecrans Spintouch
 * interrogent le service dans leur cycle de vie). Sans rechargement, ils
 * resteraient desynchronises.
 */
class DevElectronSwitch extends React.Component {

  basculer = (cle, actifActuel) => {
    devSimulation.ecrireReglage(cle, !actifActuel);

    // Un photometre ne peut pas etre branche si le service ne repond pas :
    // on coupe le Spintouch en meme temps que WaterLink pour eviter un etat
    // incoherent que le materiel reel ne produirait jamais.
    if (cle === devSimulation.CLE_WLC && actifActuel) {
      devSimulation.ecrireReglage(devSimulation.CLE_SPINTOUCH, false);
    }

    window.location.reload();
  }

  reinitialiser = (e) => {
    e.stopPropagation();
    [devSimulation.CLE_ELECTRON, devSimulation.CLE_WLC, devSimulation.CLE_SPINTOUCH]
      .forEach(devSimulation.effacerReglage);
    window.location.reload();
  }

  renderBascule = (libelle, actif, onClick, desactive) => {

    const style = {
      display        : 'flex',
      alignItems     : 'center',
      gap            : 6,
      padding        : '5px 10px',
      borderRadius   : 14,
      cursor         : desactive ? 'not-allowed' : 'pointer',
      userSelect     : 'none',
      fontSize       : 11,
      fontFamily     : 'monospace',
      color          : '#fff',
      opacity        : desactive ? 0.45 : 1,
      backgroundColor: actif ? '#0093CF' : '#555'
    };

    const pastille = {
      width          : 7,
      height         : 7,
      borderRadius   : '50%',
      backgroundColor: actif ? '#7ED321' : '#999'
    };

    return (
      <div style={style} onClick={desactive ? undefined : onClick}>
        <span style={pastille} />
        <span>{libelle} {actif ? 'ON' : 'OFF'}</span>
      </div>
    );
  }

  render() {

    if (process.env.NODE_ENV !== 'development') {
      return null;
    }

    const electron  = ElectronWaterLinkService.isElectronApp();
    const wlc       = devSimulation.serviceDisponible();
    const spintouch = devSimulation.appareilBranche();

    // La simulation materielle n'est active qu'une fois WaterLink positionne ;
    // tant qu'on n'y a pas touche, les services interrogent le vrai port 61547.
    const simulationMaterielle = devSimulation.estActive();

    const forcage =
      devSimulation.lireReglage(devSimulation.CLE_ELECTRON) !== null ||
      simulationMaterielle;

    const conteneur = {
      position     : 'fixed',
      bottom       : 16,
      right        : 16,
      zIndex       : 9999,
      display      : 'flex',
      flexDirection: 'column',
      alignItems   : 'flex-end',
      gap          : 5
    };

    return (
      <div style={conteneur}>

        {this.renderBascule('DEV · Electron', electron,
          () => this.basculer(devSimulation.CLE_ELECTRON, electron), false)}

        {this.renderBascule('DEV · WaterLink', wlc,
          () => this.basculer(devSimulation.CLE_WLC, wlc), false)}

        {this.renderBascule('DEV · Spintouch', spintouch,
          () => this.basculer(devSimulation.CLE_SPINTOUCH, spintouch), !wlc)}

        {forcage &&
          <div
            style={{
              padding     : '3px 10px',
              borderRadius: 14,
              cursor      : 'pointer',
              userSelect  : 'none',
              fontSize    : 10,
              fontFamily  : 'monospace',
              color       : '#fff',
              opacity     : 0.75,
              backgroundColor: '#333'
            }}
            onClick={this.reinitialiser}
            title="Revenir a la detection automatique (materiel reel)"
          >
            × reinitialiser
          </div>
        }

      </div>
    );
  }
}

export default DevElectronSwitch;
